<template>
  <v-navigation-drawer
    :permanent="isPersistentDrawer"
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    :mini-variant.sync="mini"
  >
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.altIcon : item.icon"
          append-icon
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.link"
            link
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.link" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <!-- <template v-slot:append>
      <div class="pa-2">
        <v-btn block color="primary">
          Logout
        </v-btn>
      </div>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalizeFirstLetter } from "../../utils/string";

export default {
  data: () => ({
    mini: false,
    items: [
      {
        icon: "mdi-home-account",
        text: "Account Info",
        link: "/account-info",
        visible: true,
      },
      {
        icon: "mdi-account-supervisor",
        text: "Users",
        link: "/user",
        visible: true,
      },
      {
        icon: "mdi mdi-account-check",
        text: "Active Users",
        link: "/active-users",
        visible: true,
      },
      {
        icon: "mdi-office-building-marker",
        oText: "Locations",
        text: "Locations",
        link: "/location",
        visible: true,
        isTerminology: true,
      },
      {
        icon: "mdi-text-box-multiple-outline",
        text: "Documents",
        link: "/account-docs",
        visible: true,
      },
      {
        icon: "mdi-file-word-box",
        text: "Terminologies",
        link: "/accountTerminology",
        visible: true,
      },
      {
        icon: "mdi-google-classroom",
        oText: "Classrooms",
        text: "Classrooms",
        link: "/classroom",
        visible: true,
        isTerminology: true,
      },
      {
        icon: "mdi-shape",
        oText: "Programs",
        text: "Programs",
        link: "/program",
        visible: true,
        isTerminology: true,
      },
      {
        icon: "mdi-calendar-question",
        text: "Appointment Types",
        link: "/appointmentType",
        visible: false,
      },
      {
        icon: "mdi-account-box",
        text: "Contact Types",
        link: "/contactType",
        visible: false,
      },
      {
        icon: "mdi-book-open-page-variant",
        text: "Manage Pages",
        link: "/manage-pages",
        visible: true,
      },
      {
        icon: "mdi-account-lock-outline",
        text: "Role",
        link: "/role",
        visible: false,
      },
      {
        icon: "mdi-view-module",
        text: "Modules",
        link: "/module",
        visible: false,
      },

      {
        icon: "mdi-email",
        text: "Email",
        link: "/settings/email",
        visible: true,
      },
      {
        icon: "mdi-email-outline",
        text: "Reminders",
        link: "/settings/reminders",
        visible: true,
      },
      {
        icon: "mdi-video-outline",
        text: "Meet Rooms",
        link: "/settings/meet",
        visible: true,
      },
      {
        icon: "mdi-check-decagram",
        text: "Checklist",
        link: "/checklist",
        visible: true,
      },
      {
        icon: "mdi-account-key",
        text: "OAuth",
        link: "/oauth2",
        visible: true,
      },
      {
        icon: "mdi-view-dashboard-edit",
        text: "Dashboard Configuration",
        link: "/dashboard-config",
        visible: true,
      },
      {
        icon: "mdi-application-cog",
        altIcon: "mdi-chevron-down",
        text: "Settings",
        children: [
          {
            icon: "mdi-credit-card",
            text: "Credit Card",
            link: "/settings/credit-card",
          },
          { icon: "mdi-email", text: "Email", link: "/settings/email" },
        ],
      },
    ],
    isPersistentDrawer: true,
  }),

  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    ...mapGetters("navigation", ["navState"]),
    ...mapGetters("terminology", ["terminologies"]),

    displayableItems() {
      const allRoutes = this.$router.options.routes;
      return this.items.filter((item) => {
        let authorize = null;
        // Use find() with a condition that supports parameterized routes.
        const route = allRoutes.find((r) => r.path.startsWith(item.link));

        if (item.isTerminology) {
          if (item.oText == "Classrooms") {
            item.text = this.terminologies.classroom;
          } else if (item.oText == "Programs" && this.terminologies.program) {
            item.text = this.terminologies.program;
          } else if (item.oText == "Locations") {
            item.text = this.terminologies.center;
          }
          item.text = capitalizeFirstLetter(item.text);
        }

        if (!item.visible) {
          return false;
        }

        if (route && route.meta) {
          authorize = route.meta.authorize;
          return this.isLoggedIn && this.isAuthorized(authorize);
        } else if (item.children) {
          authorize = item.meta ? item.meta.authorize : [];
          return this.isLoggedIn && this.isAuthorized(authorize);
        } else if (!route) {
          console.warn("Unknown route found in Sidebar: " + item.link);
          return false;
        } else {
          return true; // Include menu without authorize filter.
        }
      });
    },
  },
  created() {
    this.navState.drawer = false;
  },
  watch: {
    "navState.drawer": function () {
      if (this.isSmallScreen()) {
        this.mini = false;
        this.isPersistentDrawer = false;
      } else {
        this.isPersistentDrawer = true;
        this.mini = this.navState.drawer;
      }
    },
  },
  methods: {
    isAuthorized(roles) {
      if (!roles || roles.length < 1) {
        return true;
      }
      if (this.userRoles && this.userRoles.length > 0) {
        return this.userRoles.some((r) => roles.includes(r));
      } else {
        this.addErrorMessage("Unauthorized Access");
        return false;
      }
    },
    isSmallScreen() {
      if (screen.width <= 1024) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style></style>
